import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'newLine',
})
export class NewLinePipe implements PipeTransform {
    public transform(text: string): string {
        if (text) {
            return text.replace(new RegExp('(&#10;)|(\\n)|(\\r\\n)', 'g'), '<br>');
        } else {
            return '';
        }
    }
}
